import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import { getGuid } from 'owa-guid';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makePostRequest } from 'owa-ows-gateway';

import getEntryPoint from '../selectors/getEntryPoint';
import { getUserMailboxGuid } from '../utils/getMailboxGuid';
import getMailboxPuid from '../selectors/getMailboxPuid';

import type GenerateBookingUrlResponse from './schema/GenerateBookingUrlResponse';
import type GenerateBookingUrlRequest from './schema/GenerateBookingUrlRequest';
export default async function generateBookingUrl(
    requestBody: GenerateBookingUrlRequest
): Promise<GenerateBookingUrlResponse | null> {
    // Send the GenerateBookingUrl request with added: ?useNewRequestUrl=true, that way will be already enabling the new controller SignedUrl and CheckBookable,
    // The auth requirements for checkBookable to work with signedUrl are almost complete, needs just whitelisting the new scope in owa omaps.
    const url = 'ows/beta/BookWithMe/GenerateBookingUrl?useNewRequestUrl=true';
    const perfDatapoint = new PerformanceDatapoint('generateBookingUrl');
    perfDatapoint.addCustomData({
        meetingTypeId: requestBody.itemId ?? '',
        isSingleUse: requestBody.isSingleUse ?? '',
        isAttendeeAuthRequired: requestBody.isAttendeeAuthRequired ?? '',
        isPublic: requestBody.isPublic ?? false,
        entryPoint: getEntryPoint(),
        guid: getGuid(),
        mailboxGuid: getUserMailboxGuid(),
        bookingMailboxPuid: getMailboxPuid(),
    });
    /* eslint-disable-next-line owa-custom-rules/require-mailboxInfoInOwsRequest  -- (https://aka.ms/OWALintWiki)
     * MailboxInfo must be providded to OWS calls, see https://aka.ms/multiaccountlinter
     *	> All OWS calls must pass in a MailboxInfo or OwsRequestOptions obtained via getOwsMailboxRequestOptions. */
    const response = await makePostRequest(
        url,
        requestBody,
        getGuid() /*correlationId*/,
        true /*returnFullResponse*/,
        undefined /*customHeaders */,
        false /* throwServiceError*/,
        true /* sendPayloadAsBody*/,
        false /*includeCredentials*/,
        'generateBookingUrl' /*actionName*/
    );
    if (response && isSuccessStatusCode(response.status)) {
        perfDatapoint.end();
        return response.json();
    } else {
        perfDatapoint.endWithError(DatapointStatus.ServerError);
        return Promise.resolve(null);
    }
}
